module.exports = __webpack_public_path__ + "img/Oracles_bc.3845b29a.svg";